import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import arrowDown from '../../../../assets/images/arrowdown.svg';
import arrowUp from '../../../../assets/images/arrowup.svg';
import { ReactComponent as WinnerCup } from '../../../../assets/images/trophyIcon.svg';
import LabelWithIcon from '../../../../components/shared/Label/LabelWithIcon';

import styles from './ReferralRewardBadge.module.scss';

const ReferralRewardHeading = ({
  eligibileForRewards,
  showIcon = true,
  user,
  isCollapsed,
  onToggleCollapse,
  showToggleButton = false,
}) => {
  const { t } = useTranslation('common');
  const getArrowIcon = () => {
    if (!showToggleButton) return arrowUp;
    return isCollapsed ? arrowDown : arrowUp;
  };

  const getAriaLabel = () => {
    if (!showToggleButton) return undefined;
    return isCollapsed ? t('ariaLabels.expandRewards') : t('ariaLabels.collapseRewards');
  };

  return (
    <div className={classNames(styles.rewardHeadingContainer, { [styles.pb12]: isCollapsed })}>
      <div className={styles.badgeTitle}>
        {showIcon ? <WinnerCup /> : null}
        <div className={classNames(styles.badgeHeading, { [styles.boldText]: !showIcon })}>
          {t('referrals.referralRewards')}
        </div>
      </div>
      {!eligibileForRewards && user ? (
        <div
          className={styles.eligibilityContainer}
          onClick={showToggleButton ? onToggleCollapse : undefined}
          role="button"
          tabIndex={showToggleButton ? 0 : -1}
          aria-label={getAriaLabel()}
          onKeyDown={
            showToggleButton
              ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggleCollapse();
                  }
                }
              : undefined
          }
        >
          <LabelWithIcon
            tag={[t('referrals.notEligible')]}
            img={getArrowIcon()}
            customStyles={classNames(styles.label, { [styles.hideBorder]: isCollapsed })}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ReferralRewardHeading;
